import { format } from "date-fns";

const fmtDate = (d) => (d ? format(new Date(d), "yyyy-MM-dd") : "—");
const fmtMoney = (n) =>
   n === null || n === undefined || isNaN(n)
      ? "—"
      : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(n);

const baseBody = ({ from, to, status, sort, invoiceNo, pageIndex, pageSize }) => {
   const fd = new FormData();
   fd.append("_page_index", pageIndex ?? 0);
   fd.append("_page_size", pageSize ?? 10);
   if (from) fd.append("_from", format(from, "yyyy-MM-dd"));
   if (to) fd.append("_to", format(to, "yyyy-MM-dd"));
   fd.append("_status", status ?? "attention");
   fd.append("_sort", sort ?? "attention");
   if (invoiceNo) fd.append("_invoice_no", invoiceNo);
   return fd;
};

const SIDES = {
   statement: {
      key: "statement",
      label: "Supplier Statements",
      endpoint: "/getStatementInvoices.sz",
      rowKey: (r) => r.sup_state_detail_external_id,
      buildBody: baseBody,
      columns: [
         { key: "supplier", label: "Supplier", kind: "text" },
         { key: "invoice_no", label: "Invoice number", kind: "text" },
         { key: "invoice_date", label: "Invoice date", kind: "date" },
         { key: "statement_date", label: "Statement date", kind: "date" },
         { key: "statement_amount", label: "Statement amount", kind: "money" },
         { key: "allocated", label: "Matched", kind: "money" },
         { key: "variance", label: "Variance", kind: "money" },
         { key: "match_status", label: "Status", kind: "status" },
      ],
   },
   erp: {
      key: "erp",
      label: "Protractor (ERP)",
      endpoint: "/getInvoices.sz",
      rowKey: (r) => r.esh_external_id,
      buildBody: baseBody,
      columns: [
         { key: "supplier", label: "Supplier", kind: "text" },
         { key: "invoice_no", label: "Invoice number", kind: "text" },
         { key: "invoice_date", label: "Invoice date", kind: "date" },
         { key: "erp_amount", label: "ERP amount", kind: "money" },
         { key: "allocated", label: "Matched", kind: "money" },
         { key: "variance", label: "Variance", kind: "money" },
         { key: "match_status", label: "Status", kind: "status" },
      ],
   },
};

export const renderCell = (kind, value) => {
   if (kind === "date") return fmtDate(value);
   if (kind === "money") return fmtMoney(value);
   return value ?? "—";
};

export default SIDES;
